import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetch2, fetch3, fetch4, fetch5, fetch7, fetch8 } from "../commonApis/commonApis";
import { useDispatch } from "react-redux";
import { addDarkStore, setDarkStoreList } from "../features/darkStores/darkStoresSlice";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
    success: boolean;
    data: any;
    message?: string;
    statusCode?: number;
    statusMessage?: string;
    error?: any;
}


export const useDarkStoreRadiusCreateMutation = () => {
    return useMutation({
        mutationFn: async (payload: any) => {
            /*
            const res: ApiResponse = await fetch4(`${url}/api/dark-store/radius`, payload);

            if (!res.success) {
                throw res.message || res?.error || "Something went wrong";
            }

            return res;
            */
            return { success: true, data: {} } as any;
        },
        onSuccess: (data: any) => {
            console.log("Dark Store Created successfully:", data);
        },
        onError: (error: any) => {
            console.error("Dark Store create request failed:", error);
            return error;
        },
    });
};

export const useFetchDarkStoreRadiusData = (
    page?: number,
    limit?: number,
    searchFor?: string
) => {
    return useQuery({
        queryKey: ["darkStoreRadiusData"],
        queryFn: async () => {
            /*
            const res = await fetch3(
                `${url}/api/dark-store/dark-stores-radius/data?page=${page}&limit=${limit}&searchFor=${searchFor}`,
                "get"
            );

            if (!res || !res.data) {
                return res.message;
            }

            return res.data; // 👈 This returns your full user object
            */
            return { radius: [], totalPages: 0 } as any;
        },
        staleTime: 1000 * 60 * 5,
    });
};

export const useDarkStoreRadiusStatusMutation = (id: string) => {
    return useMutation({
        mutationFn: async (payload: any) => {
            /*
            const res: ApiResponse = await fetch5(
                `${url}/api/dark-store/radius/${id}/status`,
                "PATCH",
                payload
            );

            if (!res.success) {
                throw res.message || "Radius status update request failed";
            }

            return res;
            */
            return { success: true } as any;
        },
        onSuccess: (data: any) => {
            console.log("Radius Status updated successfully:", data);
        },
        onError: (error: any) => {
            console.error("Radius status update request failed:", error);
            return error;
        },
    });
};

export const useDarkStoreRadiusMutation = (id: string) => {
    return useMutation({
        mutationFn: async (payload: any) => {
            /*
            const res: ApiResponse = await fetch5(
                `${url}/api/dark-store/radius/${id}`,
                "PATCH",
                payload
            );

            if (!res.success) {
                throw res.message || res?.error || "Radius update request failed";
            }

            return res;
            */
            return { success: true } as any;
        },
        onSuccess: (data: any) => {
            console.log("Radius updated successfully:", data);
        },
        onError: (error: any) => {
            console.error("Radius update request failed:", error);
            return error;
        },
    });
};

export const useFetchDarkStoreRadiusAllData = () => {
    return useQuery({
        queryKey: ["radiusAllData"],
        queryFn: async () => {
            /*
            const res = await fetch3(`${url}/api/dark-store/radius/all`, "get");

            if (!res || !res.data) {
                return res.message
            }

            return res.data;
            */
            return [] as any;
        },
        staleTime: 1000 * 60 * 5,
    });
};

export const useDarkStoreCreateMutation = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: any) => {
            /*
            const res: ApiResponse = await fetch8(`${url}/api/dark-store`,'POST', payload);

            if (!res.success) {
                throw res.message || "Something went wrong";
            }

            return res;
            */
            return { success: true, data: {} } as any;
        },
        onSuccess: (data: any) => {
            console.log("Dark Store Created successfully:", data);
            // dispatch(addDarkStore(data));

            // Invalidate and refetch driver list queries to ensure data consistency
            // queryClient.invalidateQueries({ queryKey: ["driverList"] });
        },
        onError: (error: any) => {
            console.error("Dark Store create request failed:", error.message);
            return error;
        },
    });
};

export const useFetchDarkStoreAllData = () => {
    return useQuery({
        queryKey: ["darkStoreAllData"],
        queryFn: async () => {
            /*
            const res = await fetch3(`${url}/api/dark-store/all-data`, "get");

            if (!res || !res.data) {
                return res.message
            }

            return res.data;
            */
            return [] as any;
        },
        staleTime: 1000 * 60 * 5,
    });
};

export const useFetchDarkStoresData = (
    page?: number,
    limit?: number,
    searchFor?: string
) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["darkStoreRadiusData"],
        queryFn: async () => {
            /*
            const res = await fetch3(
                `${url}/api/dark-store?page=${page}&limit=${limit}&searchFor=${searchFor}`,
                "get"
            );

            if (!res || !res.data) {
                return res.message;
            }
            console.log(res?.data, 'data')

            dispatch(setDarkStoreList(res.data));
            return res.data; // 👈 This returns your full user object
            */
            return { results: [], total: 0 } as any;
        },
        staleTime: 1000 * 60 * 5,
    });
};

export const useFetchDarkStoreDetailsData = (id?: string) => {
    return useQuery({
        queryKey: ["darkStoreDetailsData", id],
        queryFn: async () => {
            /*
            if (!id) return null;
            const res = await fetch3(`${url}/api/dark-store/${id}`, "get");
            if (!res || !res.data) return res.message;
            return res.data;
            */
            return {} as any;
        },
        enabled: !!id, // 👈 run only when id exists
        staleTime: 1000 * 60 * 5,
    });
};

export const useDarkStoreStatusMutation = (id: string) => {
    return useMutation({
        mutationFn: async (payload: any) => {
            /*
            const res: ApiResponse = await fetch5(
                `${url}/api/dark-store/${id}/status`,
                "PATCH",
                payload
            );

            if (!res.success) {
                throw res.message || "Something went wrong";
            }

            return res;
            */
            return { success: true } as any;
        },
        onSuccess: (data: any) => {
            console.log("Dark Store status updated successfully:", data);
        },
        onError: (error: any) => {
            console.error("Dark Store status updated request failed:", error.message);
            return error;
        },
    });
};

export const useDarkStoreDriverAssignmentTypeMutation = (id: string) => {
    return useMutation({
        mutationFn: async (payload: any) => {
            /*
            const res: ApiResponse = await fetch5(
                `${url}/api/dark-store/${id}/add-driver-assignment-type`,
                "PATCH",
                payload
            );

            if (!res.success) {
                throw res.message || "Something went wrong";
            }

            return res;
            */
            return { success: true } as any;
        },
        onSuccess: (data: any) => {
            console.log("Dark Store driver-assignment-type updated successfully:", data);
        },
        onError: (error: any) => {
            console.error("Dark Store driver-assignment-type updated request failed:", error.message);
            return error;
        },
    });
};

export const useDarkStoreAddRadiusMutation = (id: string) => {
    return useMutation({
        mutationFn: async (payload: any) => {
            /*
            const res: ApiResponse = await fetch5(
                `${url}/api/dark-store/${id}/add-radius`,
                "PATCH",
                payload
            );

            if (!res.success) {
                throw res.message || "Something went wrong";
            }

            return res;
            */
            return { success: true } as any;
        },
        onSuccess: (data: any) => {
            console.log("Dark Store radius updated successfully:", data);
        },
        onError: (error: any) => {
            console.error("Dark Store radius updated request failed:", error.message);
            return error;
        },
    });
};

export const useDarkStoreUpdateMutation = (id: string) => {
    return useMutation({
        mutationFn: async (payload: any) => {
            /*
            const res: ApiResponse = await fetch7(
                `${url}/api/dark-store/${id}`,
                "PUT",
                payload
            );

            // Manually throw error if success is false
            if (!res.success) {
                throw res.message || "Something went wrong";
            }

            return res;
            */
            return { success: true } as any;
        },
        onSuccess: (data: any) => {
            console.log("✅ Staff Created successfully:", data);
        },
        onError: (error: any) => {
            console.error("❌ staff create request failed:", error.message);
            return error;
        },
    });
};

// ─── Client Darkstores ─────────────────────────────────────────────────────────────

export const useFetchClientDarkStoresData = () => {
    return useQuery({
        queryKey: ["clientDarkStores"],
        queryFn: async () => {
            /*
            const res = await fetch3(`${url}/api/dark-store/client-darkstores`, "get");

            if (!res || !res.data) {
                return [];
            }

            return res.data;
            */
            return [] as any;
        },
        staleTime: 1000 * 60 * 5,
    });
};

// ─── Darkstore Branches ───────────────────────────────────────────────────────────

export const useFetchDarkStoreBranchesData = (darkstoreId?: string) => {
    return useQuery({
        queryKey: ["darkStoreBranches", darkstoreId],
        queryFn: async () => {
            /*
            if (!darkstoreId) return [];
            const res = await fetch3(`${url}/api/dark-store/${darkstoreId}/branches`, "get");

            if (!res || !res.data) {
                return [];
            }

            return res.data;
            */
            return [] as any;
        },
        enabled: !!darkstoreId,
        staleTime: 1000 * 60 * 5,
    });
};
